import { useTranslation } from 'react-i18next'
import type { CampaignListStats } from '../../api/campaigns'

interface CampaignProgressProps {
  name: string
  stats: CampaignListStats
}

export function CampaignProgress({ name, stats }: CampaignProgressProps) {
  const { t } = useTranslation('campaigns')
  const pct = stats.total > 0 ? Math.round((stats.contacted / stats.total) * 100) : 0

  return (
    <div className="rounded-lg border border-border bg-surface-card p-4">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-text-primary">{name}</h2>
        <span className="text-sm text-text-muted">
          {t('list.calledOf', { contacted: stats.contacted, total: stats.total })}
        </span>
      </div>
      <div className="mt-3">
        <div className="h-2.5 w-full overflow-hidden rounded-full bg-surface-elevated">
          <div
            className="h-full rounded-full bg-primary transition-all duration-500"
            style={{ width: `${pct}%` }}
          />
        </div>
        <div className="mt-2 flex justify-between text-xs text-text-muted">
          <span>{pct}%</span>
          <span>{t('list.remaining', { count: stats.remaining })}</span>
        </div>
      </div>
    </div>
  )
}
